import { deserializeSession, parseToken } from '@finam/txservices-auth/utils';

var getUserIdByToken = function getUserIdByToken(token) {
  var _a;

  try {
    var parsed = parseToken(token);
    var session = deserializeSession(parsed);
    return (_a = session.person) === null || _a === void 0 ? void 0 : _a.id;
  } catch (_b) {
    return undefined;
  }
};

export default getUserIdByToken;